export default __webpack_public_path__ + "static/media/awaiting5S.72636b3b.svg";